import {ChangeDetectorRef, Component, ElementRef, Input, OnInit} from "@angular/core";
import {Observable} from "rxjs";
import {ModalService} from "../../../../../services/ui/modal.service";
import {SubscriptionLike as ISubscription} from "rxjs/internal/types";
import {CacheService} from "../../../../../services/sys/cache.service";

@Component({
    selector: 'efast-modal-processing',
    templateUrl: 'efast-modal-processing.component.html',
    styleUrls: ['./efast-modal-processing.component.css'],
    standalone: false
})
export class EfastModalProcessingComponent implements OnInit {
    modalSubscription: ISubscription = null;
    private show: boolean = false;
    private msg: string = "";

    constructor(private el: ElementRef,
                private modalService: ModalService,
                private cacheService: CacheService) {
        this.modalSubscription = this.modalService.modalProcessingServiceSubject.subscribe(data => this.modalChangeEvent(data));

    }
    private modalChangeEvent(data) {

        if (this.modalService.isShow()) {
            this.show = true;
            this.el.nativeElement.classList.add('sshow')
        }
        else {
            this.show = false;
            this.el.nativeElement.classList.add('hhidden')
        }

    }
    ngOnInit() {
        this.msg = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONModalProcessingMsg');

    }
    close() {
        this.modalService.setShow(false);
        this.show = false;
        this.el.nativeElement.classList.remove('sshow')
        this.el.nativeElement.classList.add('hhidden')
    }
}
